import React from 'react';
import { Check } from 'lucide-react';
import { Reveal } from '../Reveal';
import { incluyeCadaTomo } from '../../data/content';
export function IncluyeCadaTomo() {
  return <section aria-labelledby="incluye-titulo" className="w-full bg-[#F3F4F6] px-4 py-16 sm:px-6 sm:py-20" data-id="element-172" data-mp="1qdxkr4eoafze">
      <div className="mx-auto max-w-5xl" data-id="element-173" data-mp="1mclqglkut6kv">
        <Reveal data-id="element-174" data-mp="1mdwt2i2kc8ae">
          <div className="overflow-hidden rounded-2xl border border-dorado/35 border-l-[6px] border-l-bordo bg-[#FFF8EC] px-5 py-10 shadow-[0_14px_32px_rgba(17,24,39,0.12)] sm:px-10 sm:py-12" data-id="element-175" data-mp="1me59gjxw9vqc">
            <h2 id="incluye-titulo" className="text-center font-display text-3xl font-bold text-bordo sm:text-4xl" data-id="element-176" data-mp="2e49y4usot4xd">
              Cada tomo incluye:
            </h2>

            <ul className="mt-10 grid gap-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-5" data-id="element-177" data-mp="25a52ly2lz5bi">
              {incluyeCadaTomo.map(item => <li key={item} className="flex h-full items-start gap-3 rounded-xl border border-white/80 bg-white/80 p-5 shadow-[0_4px_12px_rgba(17,24,39,0.04)]" data-id="element-178" data-mp="31udr88891ma4">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 border-verde text-verde" data-id="element-179" data-mp="2oqfnf11385fg">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-180" data-mp="2ez1rf38chnr2" />
                  </span>
                  <span className="text-sm font-medium leading-relaxed text-tinta sm:text-base" style={{
                fontSize: "12px"
              }} data-id="element-181" data-mp="2jw1z1ikueyka">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}